import { DoughnutChart } from '@commenda/kakashi';

function generateChartData(owners: { sharePercentage?: number }[]) {
  const finalNumbers = owners.map((owner) => owner.sharePercentage);

  return { values: finalNumbers };
}

const addUnassignedOwner = (
  owners: { name: string; sharePercentage?: number }[]
) => {
  const totalOwned = owners.reduce((sum, owner) => {
    return sum + (owner.sharePercentage || 0);
  }, 0);

  const unassignedSharePercentage = Math.max(100 - totalOwned, 0);

  let newOwners = owners;
  if (!newOwners.length) return newOwners;

  if (newOwners[newOwners.length - 1].name === 'Unassigned') {
    newOwners[newOwners.length - 1].sharePercentage = unassignedSharePercentage;
  } else {
    newOwners = newOwners.concat([
      {
        name: 'Unassigned',
        sharePercentage: unassignedSharePercentage,
      },
    ]);
  }

  return newOwners;
};

const EquitySplitDonutChart = ({
  owners,
  colors,
  placeholderColor,
}: {
  owners: { name: string; sharePercentage: number }[];
  colors: string[];
  placeholderColor?: string;
}) => {
  let newColors = colors;

  if (placeholderColor && colors.length > owners.length) {
    newColors = colors.slice(0, owners.length).concat([placeholderColor]);
  }

  const labels = owners?.map((owner) => owner.name);

  return (
    <div className="flex items-center justify-center relative h-40 w-40">
      <DoughnutChart
        values={generateChartData(addUnassignedOwner(owners)).values}
        colors={newColors}
        labels={labels}
      />
    </div>
  );
};

export default EquitySplitDonutChart;
